<div #addbutton *ngxPermissionsOnly="['view.show.curate']">
	<p-splitButton  *ngIf="containerAddTypes?.length > 0"label="{{this.defaultLabel}}" icon="pi pi-plus" [model]="containerAddTypes" (onClick)="defaultAction()" [appendTo]="addbutton" data-element-id="app-content-components-container-add-splitbutton"></p-splitButton>
	<button *ngIf="containerAddTypes?.length == 0" pButton type="button" label="Add" [disabled]="jobInProgress" [routerLink]="['/containers', parentContainer?.id, 'relate', defaultRelateType]" icon="pi pi-plus" style="float:right;margin-left:4px;height:100%;"></button>
</div>



